export const DEFAULT_SORT = {
  sortBy: 'taxonGroup',
  sortDirection: 'ASC',
  secondarySortBy: 'scientificName',
  secondarySortDirection: 'ASC'
}

const SORT_DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC'
}

const compareStrings = (left = '', right = '', direction = SORT_DIRECTION.ASC) => {
  const normalizedLeft = String(left).toLowerCase()
  const normalizedRight = String(right).toLowerCase()

  if (normalizedLeft < normalizedRight) {
    return direction === SORT_DIRECTION.DESC ? 1 : -1
  }

  if (normalizedLeft > normalizedRight) {
    return direction === SORT_DIRECTION.DESC ? -1 : 1
  }

  return 0
}

const compareNumbers = (left, right, direction = SORT_DIRECTION.ASC) => {
  const leftIsEmpty = left == null || Number.isNaN(Number(left))
  const rightIsEmpty = right == null || Number.isNaN(Number(right))

  if (leftIsEmpty && rightIsEmpty) {
    return 0
  }

  if (leftIsEmpty) {
    return 1
  }

  if (rightIsEmpty) {
    return -1
  }

  const leftValue = Number(left)
  const rightValue = Number(right)

  if (leftValue < rightValue) {
    return direction === SORT_DIRECTION.DESC ? 1 : -1
  }

  if (leftValue > rightValue) {
    return direction === SORT_DIRECTION.DESC ? -1 : 1
  }

  return 0
}

const compareBooleans = (left, right, direction = SORT_DIRECTION.ASC) => {
  const leftRank = left === true ? 1 : left === false ? 0 : -1
  const rightRank = right === true ? 1 : right === false ? 0 : -1

  if (leftRank < rightRank) {
    return direction === SORT_DIRECTION.DESC ? 1 : -1
  }

  if (leftRank > rightRank) {
    return direction === SORT_DIRECTION.DESC ? -1 : 1
  }

  return 0
}

const getSortValue = (row, sortBy) => {
  if (row?.sortValues && row.sortValues[sortBy] != null) {
    return row.sortValues[sortBy]
  }

  return row?.[sortBy]
}

const compareRows = (left, right, sortBy, direction) => {
  const leftValue = getSortValue(left, sortBy)
  const rightValue = getSortValue(right, sortBy)

  if (sortBy === 'reproductiveUnits' || sortBy === 'population' || sortBy === 'siteBest') {
    return compareNumbers(leftValue, rightValue, direction)
  }

  if (sortBy === 'globallySensitive') {
    return compareBooleans(leftValue, rightValue, direction)
  }

  return compareStrings(leftValue, rightValue, direction)
}

export const sortCalculationRows = (rows = [], sortConfig = null) => {
  const activeSort = sortConfig?.sortBy ? sortConfig : DEFAULT_SORT
  const direction = activeSort.sortDirection === SORT_DIRECTION.DESC
    ? SORT_DIRECTION.DESC
    : SORT_DIRECTION.ASC

  return [...rows]
    .map((row, index) => ({ row, index }))
    .sort((left, right) => {
      const primaryComparison = compareRows(left.row, right.row, activeSort.sortBy, direction)

      if (primaryComparison !== 0) {
        return primaryComparison
      }

      if (activeSort.sortBy !== DEFAULT_SORT.secondarySortBy) {
        const secondaryComparison = compareStrings(
          getSortValue(left.row, DEFAULT_SORT.secondarySortBy),
          getSortValue(right.row, DEFAULT_SORT.secondarySortBy),
          DEFAULT_SORT.secondarySortDirection
        )

        if (secondaryComparison !== 0) {
          return secondaryComparison
        }
      }

      return left.index - right.index
    })
    .map(({ row }) => row)
}

export const getNextSortState = (currentSort, columnId) => {
  if (!currentSort?.sortBy || currentSort.sortBy !== columnId) {
    return { sortBy: columnId, sortDirection: SORT_DIRECTION.ASC }
  }

  if (currentSort.sortDirection === SORT_DIRECTION.ASC) {
    return { sortBy: columnId, sortDirection: SORT_DIRECTION.DESC }
  }

  return DEFAULT_SORT
}
